import { GlCard, GlModal, GlSprintf, GlLink, GlLoadingIcon, GlToggle, GlToastMixin } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sortBy } from 'lodash-es';
import Api from '/builds/gitlab/gitlab-ee/app/assets/javascripts/api.js?vue3';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
import { i18n } from '../constants';
export default {
    name: 'CustomNotificationsModal',
    components: {
        GlCard,
        GlModal,
        GlSprintf,
        GlLink,
        GlLoadingIcon,
        GlToggle
    },
    mixins: [
        glListenersMixin,
        GlToastMixin
    ],
    inject: {
        projectId: {
            default: null
        },
        groupId: {
            default: null
        },
        helpPagePath: {
            default: ''
        }
    },
    model: {
        prop: 'visible',
        event: 'change'
    },
    props: {
        modalId: {
            type: String,
            required: false,
            default: 'custom-notifications-modal'
        },
        visible: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            isLoading: false,
            events: []
        };
    },
    methods: {
        buildEvents (events) {
            const eventKeys = Object.keys(events).filter((key)=>key in this.$options.i18n.eventNames);
            const rawEvents = eventKeys.map((key)=>({
                    id: key,
                    enabled: Boolean(events[key]),
                    name: this.$options.i18n.eventNames[key] || '',
                    loading: false
                }));
            return sortBy(rawEvents, 'name');
        },
        async onOpen () {
            if (!this.events.length) {
                await this.loadNotificationSettings();
            }
        },
        async loadNotificationSettings () {
            this.isLoading = true;
            try {
                const { data: { events } } = await Api.getNotificationSettings(this.projectId, this.groupId);
                this.events = this.buildEvents(events);
            } catch (error) {
                this.$toast.show(this.$options.i18n.loadNotificationLevelErrorMessage);
            } finally{
                this.isLoading = false;
            }
        },
        async updateEvent (isEnabled, event) {
            const index = this.events.findIndex((e)=>e.id === event.id);
            // update loading state for the given event
            this.events.splice(index, 1, {
                ...this.events[index],
                loading: true
            });
            try {
                const { data: { events } } = await Api.updateNotificationSettings(this.projectId, this.groupId, {
                    [event.id]: isEnabled
                });
                this.events = this.buildEvents(events);
            } catch (error) {
                this.$toast.show(this.$options.i18n.updateNotificationLevelErrorMessage);
            }
        }
    },
    i18n
};
